import {Mapper} from '@s-ui/domain'

export default class FromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper extends Mapper {
  constructor({relatedVehiclesListValueObject, relatedVehicleValueObject}) {
    super()
    this._relatedVehicleValueObject = relatedVehicleValueObject
    this._relatedVehiclesListValueObject = relatedVehiclesListValueObject
  }

  map = ({relatedVehicles}) => {
    const items = relatedVehicles.map(({make, model, url, imageUrl, doors}) =>
      this._relatedVehicleValueObject({make, model, url, imageUrl, doors})
    )
    return this._relatedVehiclesListValueObject({items})
  }
}
